import { useLazyQuery, useQuery } from "@apollo/client/react";
import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import toast from 'react-hot-toast';
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import DocumentViewer from '../../../../../components/DocumentViewer';
import GET_DOCUMENTOS_VISITAS, { adaptDocumentosArray } from "../../../../../data/graphQL/queries/GestionAsistencial/getDocumentosVisitasAsistencial";
import GET_DOCUMENTOS_VISITAS_NUEVAS, { adaptDocumentosVisitasNuevasArray } from "../../../../../data/graphQL/queries/GestionAsistencial/getDocumentosVisitasNuevasAsistencial";
import { useTabDocumentacion } from "../../hooks/TabDocumentacion/useTabDocumentacion";
import { useTabDocumentacionVisitasNuevas } from "../../hooks/TabDocumentacion/useTabDocumentacionVisitasNuevas";

export function TabDocumentacionVisitas({
  evaluacionSelected
}) {
  const { idEvaluacion } = evaluacionSelected;
  const [visitas, setVisitas] = useState([]);
  const { columns, fileToView, resetFileToView } = useTabDocumentacion('visitas', visitas);
  const [visitasNuevas, setVisitasNuevas] = useState([]);
  const { columnsNuevas, fileToViewNuevas, resetFileToViewNuevas } = useTabDocumentacionVisitasNuevas(visitasNuevas);

  const { data: dataDocumentosVisitas } = useQuery(GET_DOCUMENTOS_VISITAS, {
    variables: {
      idEvaluacion: idEvaluacion
    },
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (!dataDocumentosVisitas) return;
    setVisitas(adaptDocumentosArray(dataDocumentosVisitas));
  }, [dataDocumentosVisitas]);

  useEffect(() => {
    if (!loadingVisitasNuevas)
      getVisitasNoMedico({ variables: { idEvaluacion: idEvaluacion } });
  }, [idEvaluacion]);

  const [getVisitasNoMedico, { data: dataVisitasNoMedico, loading: loadingVisitasNuevas }] = useLazyQuery(GET_DOCUMENTOS_VISITAS_NUEVAS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataVisitasNoMedico) return;
    if (dataVisitasNoMedico.visitasNoMedico.success) {
      setVisitasNuevas(adaptDocumentosVisitasNuevasArray(dataVisitasNoMedico.visitasNoMedico.valorEsperado));
    } else {
      toast.error('Error al consultar las visitas.');
    }
  }, [dataVisitasNoMedico]);

  return (
    <div className='generic-tab-container' style={{ marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography sx={{ fontSize: "16px", fontWeight: "600", mb: "20px" }}>
            Visitas cargadas
          </Typography>
          <DataGridGenerico
            columns={columns}
            rows={visitas}
            totalCount={visitas?.length || 0}
            toolbar={false} />

          <br />
          <DataGridGenerico
            columns={columnsNuevas}
            rows={visitasNuevas}
            totalCount={visitasNuevas?.length || 0}
            toolbar={false}
            isLoading={loadingVisitasNuevas} />

        </Grid>
      </Grid>
      {fileToView && <DocumentViewer data={fileToView} setOpenDlg={resetFileToView} download={true} />}
      {fileToViewNuevas && <DocumentViewer data={fileToViewNuevas} setOpenDlg={resetFileToViewNuevas} download={true} />}
    </div>);

}